/* FAB POPS motion layer.
   Lenis smooth scroll + GSAP ScrollTrigger + SplitText heading reveals.
   Libraries are loaded from CDN by snippets/fab-motion.liquid.
   Everything here fails safe: if a library is missing, the page just works without motion. */
(function () {
  'use strict';

  var root = document.documentElement;
  var HEADINGS = 'main .s-header__heading, main h2:not(.card__heading):not(.product__title)';

  function boot() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var isHome = document.body.classList.contains('template-index');
    var pending = Promise.resolve();

    try {
      if (!window.gsap || !window.ScrollTrigger) {
        root.classList.add('fab-off');
        return;
      }
      gsap.registerPlugin(ScrollTrigger);
      if (window.SplitText) gsap.registerPlugin(SplitText);

      if (!reduce) {
        smoothScroll();
        progressBar();
        if (isHome) {
          heroSettle();
          imageReveal();
          if (finePointer) magneticButtons();
          pending = splitHeadings();
        }
        window.addEventListener('load', function () { ScrollTrigger.refresh(); });
      }
    } catch (err) {
      root.classList.add('fab-off');
    }

    function ready() { root.classList.add('fab-ready'); }
    pending.then(ready, ready);
  }

  /* Lenis smooth scroll, kept in step with ScrollTrigger.
     Touch devices keep native scrolling. */
  function smoothScroll() {
    if (!window.Lenis) return;
    var lenis = new Lenis({ lerp: 0.1, smoothWheel: true, allowNestedScroll: true });
    window.fabLenis = lenis;

    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);

    /* Pause smooth scroll while the cart drawer, menu or a dialog locks the page */
    function sync() {
      var b = document.body;
      var locked = b.classList.contains('o-hidden') || b.style.overflow === 'hidden';
      if (locked && !lenis.isStopped) lenis.stop();
      else if (!locked && lenis.isStopped) lenis.start();
    }
    new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    sync();
  }

  /* Thin red progress bar across the top of the page */
  function progressBar() {
    var bar = document.createElement('div');
    bar.className = 'fab-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    gsap.set(bar, { scaleX: 0, transformOrigin: '0 50%' });
    gsap.to(bar, {
      scaleX: 1,
      ease: 'none',
      scrollTrigger: { start: 0, end: 'max', scrub: 0.3 }
    });
  }

  /* Hero banner eases in from a slight zoom */
  function heroSettle() {
    var imgs = document.querySelectorAll('[id$="__slideshow_hero"] img');
    if (!imgs.length) return;
    gsap.fromTo(imgs, { scale: 1.06 }, { scale: 1, duration: 1.8, ease: 'power3.out', clearProps: 'transform' });
  }

  /* Wipe reveal on the car mount photo, no cropping once it lands */
  function imageReveal() {
    var imgs = document.querySelectorAll('[id$="__image_with_text_magsafe"] img');
    Array.prototype.forEach.call(imgs, function (img) {
      gsap.fromTo(img,
        { clipPath: 'inset(0% 0% 100% 0%)', scale: 1.08 },
        {
          clipPath: 'inset(0% 0% 0% 0%)',
          scale: 1,
          duration: 1.3,
          ease: 'power3.out',
          clearProps: 'clipPath,transform',
          scrollTrigger: { trigger: img, start: 'top 85%', once: true }
        });
    });
  }

  /* Gentle magnetic pull on call-to-action links (mouse devices only).
     Links only, so add-to-cart buttons are never moved. */
  function magneticButtons() {
    var links = document.querySelectorAll('main a.btn-primary');
    Array.prototype.forEach.call(links, function (el) {
      var xTo = gsap.quickTo(el, 'x', { duration: 0.4, ease: 'power3.out' });
      var yTo = gsap.quickTo(el, 'y', { duration: 0.4, ease: 'power3.out' });
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        xTo((e.clientX - (r.left + r.width / 2)) * 0.18);
        yTo((e.clientY - (r.top + r.height / 2)) * 0.25);
      });
      el.addEventListener('pointerleave', function () { xTo(0); yTo(0); });
    });
  }

  /* Section headings rise into place word by word as they scroll into view */
  function splitHeadings() {
    if (!window.SplitText) return Promise.resolve();
    var list = document.querySelectorAll(HEADINGS);
    var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    var timeout = new Promise(function (resolve) { setTimeout(resolve, 1200); });

    return Promise.race([fontsReady, timeout]).then(function () {
      Array.prototype.forEach.call(list, function (el) {
        if (!el.textContent.trim()) return;
        if (el.querySelector('svg, button, form, input, img')) return;
        SplitText.create(el, {
          type: 'lines,words',
          mask: 'lines',
          autoSplit: true,
          onSplit: function (self) {
            return gsap.from(self.words, {
              yPercent: 115,
              duration: 0.9,
              ease: 'power4.out',
              stagger: 0.05,
              scrollTrigger: { trigger: el, start: 'top 90%', once: true }
            });
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
